// extracted by mini-css-extract-plugin
export var adjacentSlide = "_n8-9";
export var arrowButtonContainer = "_n8-5";
export var arrowButtonIcon = "_n8-6";
export var carouselArrowButton = "_n8-2";
export var carouselElementContainer = "_n8-1";
export var currentSlide = "_n8-8";
export var left = "_n8-3";
export var otherSlide = "_n8-a";
export var productCarouselContainer = "_n8-0";
export var right = "_n8-4";
export var sliderOverflow = "_n8-7";